import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/20_wood/20_wood"
 * Contains 1 texture(s)
 */
export class Tablet20WoodAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/20_wood/20_wood';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '20_wood.jpg'
    ] as const;
}
